import { Webhook, Session } from "./modules";
import { Client } from "./client";
import { Config } from "./interfaces";

export class StreamPay {
  private client: Client;
  public webhook: Webhook;
  public session: Session;

  constructor(options: Config) {
    this.client = new Client(options);
    this.webhook = new Webhook(this.client);
    this.session = new Session(this.client, options.network, options.config);
  }
}
